// extracted by mini-css-extract-plugin
export default {"reward_container":"rewardCenter_reward_container__BNsfJ","certificate_center":"rewardCenter_certificate_center__CsY7s"};